import * as $ from 'jquery'

export const checkbox_permission_column = (isChecked: boolean, value1: string, value2: string ) => {
	const checkboxes = $('#permissions-input-wrapper').find('input[type=checkbox][name|="group_"]');
	checkboxes.each((i, element) => {
		const e = $(element)
		if (e.val() == value1 || e.val() == value2)
			e.prop('checked', isChecked)
	})
}



// WEBPACK FOOTER //
// ./src/memory/component/checkbox_permission_column.ts